import { StyleSheet } from 'react-native';

import { blackTransparent } from 'utils/colors';
import {
    heightPercentageToDP,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: blackTransparent(0.9),
    },
    safeArea: {
        flex: 1,
        paddingTop: heightPercentageToDP(20),
        paddingHorizontal: widthPercentageToDP(44),
    },
    contentWrapper: {
        justifyContent: 'center',
        paddingHorizontal: widthPercentageToDP(55),
        marginTop: widthPercentageToDP(45),
        flexDirection: 'row',
    },
    closeContainer: {
        position: 'absolute',
        top: 0,
        right: 0,
    },
    close: {
        width: 40,
        height: 40,
        // @ts-ignore
        cursor: 'pointer',
    },
    closeSvg: {
        width: 16,
        height: 16,
    },
});

export default styles;
